import Factory from '../utils/factory'

export default Factory({
  id: null,
  expiresAt: null,
  data: null,
  template: {
    attachments: [],
  },
})
